var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install-app__steps-wrapper--step"},[_c('success-step',{attrs:{"billing-plan":_vm.billingPlan,"logger-link-data":_vm.loggerLinkData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }